"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.concatNonEmptyStrings = exports.getStrByte = exports.doesTranslationKeyExist = exports.startCase = exports.toUpperCase = exports.toCamelCaseWithUnderScore = exports.toSentenceCase = exports.toCamelCase = exports.addEllipsis = exports.customStartCase = exports.titleCase = exports.stripCharacters = exports.replaceSpaceAndLowerCase = exports.renderFormattedLabel = exports.renderFormattedHTMLLabel = exports.mapToDashIfEmptyString = exports.lowerCaseAndReplaceSpace = exports.getYesOrNo = exports.getLocalizedString = exports.generateLocale = exports.displayValue = exports.customKebabCaseWithoutHyphen = exports.customKebabCase = exports.hasJapanese = exports.arrayToCustomKebabCase = undefined;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _ramda = require("ramda");

var _reactIntl = require("react-intl");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var REGEX_CHINESE_JAPANESE = /[\u3000-\u303f]|[\u3040-\u309f]|[\u30a0-\u30ff]|[\uff00-\uff9f]|[\u4e00-\u9faf]|[\u3400-\u4dbf]/;

var StringUtility = {
  arrayToCustomKebabCase: function arrayToCustomKebabCase(arr) {
    var _this = this;

    return [].concat(_toConsumableArray(arr)).map(function (item) {
      return _this.customKebabCase(item);
    });
  },
  hasJapanese: function hasJapanese(str) {
    return REGEX_CHINESE_JAPANESE.test(str);
  },
  customKebabCase: function customKebabCase(value) {
    if ((0, _ramda.isNil)(value)) {
      return '';
    }

    var kebabed = !value ? '' : hasJapanese(value) ? value : value.replace(/[\W_]/g, "-").replace(/-+/g, "-").toLowerCase();

    // Convert non-alphanumeric characters to hyphens
    var result = value.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '-');

    // replace spaces by -
    result = result.replace(/ /g, '-');

    // multiple hypen to single hyphen
    result = result.replace(/-{2,}/g, '-');

    // Convert non-camelCase capitals to lowercase.
    result = result.toLowerCase();

    return kebabed === '-' ? result : kebabed;
  },
  customKebabCaseWithoutHyphen: function customKebabCaseWithoutHyphen(value) {
    return !value ? '' : value.replace(/-+/g, "-");
  },
  displayValue: function displayValue(value) {
    return !value ? '-' : value;
  },
  generateLocale: function generateLocale() {
    var currentConfiguration = window.fundsMarketingConfiguration;
    if ((0, _ramda.isNil)(currentConfiguration) || (0, _ramda.isNil)(currentConfiguration.language) || (0, _ramda.isNil)(currentConfiguration.country)) {
      return 'en-US';
    }
    return "" + (currentConfiguration.language + '-' + currentConfiguration.country.toUpperCase());
  },
  getLocalizedString: function getLocalizedString(intl, defaultString, key, values) {
    if ((0, _ramda.isNil)(intl) || (0, _ramda.isNil)(key) || (0, _ramda.isEmpty)(key) || typeof intl.formatMessage !== "function") {
      return defaultString;
    }

    return intl.formatMessage({ defaultMessage: defaultString, id: key }, values);
  },
  getYesOrNo: function getYesOrNo(value) {
    if ((0, _ramda.isNil)(value)) {
      return null;
    }

    var returnVal = null;
    if ('Y' === value) {
      returnVal = renderFormattedLabel("Yes", "pdp-yes-label");
    }

    if ('N' === value) {
      returnVal = renderFormattedLabel("No", "pdp-no-label");
    }

    return returnVal;
  },
  lowerCaseAndReplaceSpace: function lowerCaseAndReplaceSpace(str) {
    return (0, _ramda.toLower)(str).replace(/ /g, "_");
  },
  mapToDashIfEmptyString: function mapToDashIfEmptyString(value) {
    return value === "" ? "-" : value;
  },
  renderFormattedHTMLLabel: function renderFormattedHTMLLabel(defaultLabel, key, values) {
    if ((0, _ramda.isNil)(key)) {
      return defaultLabel;
    }

    defaultLabel += '';
    return React.createElement(_reactIntl.FormattedHTMLMessage, {
      id: key,
      defaultMessage: defaultLabel,
      values: values
    });
  },
  renderFormattedLabel: function renderFormattedLabel(defaultLabel, key, values) {
    if ((0, _ramda.isNil)(key)) {
      return defaultLabel;
    }

    defaultLabel += '';
    return React.createElement(_reactIntl.FormattedMessage, {
      key: key,
      id: key,
      defaultMessage: defaultLabel,
      values: values
    });
  },
  replaceSpaceAndLowerCase: function replaceSpaceAndLowerCase(str) {
    return str.toLowerCase().replace(/\s+/, '');
  },
  stripCharacters: function stripCharacters(str) {
    return str.replace(/[a-z]/gi, "");
  },
  titleCase: function titleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  customStartCase: function customStartCase(str) {
    if (!(0, _ramda.isNil)(str)) {
      return mapIndexed(function (word) {
        return word.substr(0, 1).toUpperCase() + word.substr(1, word.length - 1);
      }, str.split("-")).join(" ");
    } else {
      return str;
    }
  },
  addEllipsis: function addEllipsis(input, limit) {
    if (input.split("").length > limit) {
      var str = void 0;
      if (input.toUpperCase() === input) {
        str = input;
      } else {
        str = toCamelCase(input);
      }
      str = str.slice(0, limit - 4);
      if (str.substring(str.length - 1) === " ") {
        return toSentenceCase(str.slice(0, str.length - 2));
      } else if (str.substring(str.length - 1) === ",") {
        return toSentenceCase(str.slice(0, str.length - 1));
      } else {
        var pos = str.lastIndexOf(",");
        if (pos !== -1) {
          return toSentenceCase(str.slice(0, pos));
        }
      }
      return toSentenceCase(str + "...");
    }
    return input;
  },
  toCamelCase: function toCamelCase(input) {
    return input.replace(/\s+(.)/g, function (match, group) {
      return group.toUpperCase();
    });
  },
  toCamelCaseWithUnderScore: function toCamelCaseWithUnderScore(input) {
    return input.toLowerCase().replace(/(_|-)([a-z])/g, toUpperCase);
  },
  toUpperCase: function toUpperCase(input) {
    return input[1].toUpperCase();
  },
  startCase: function startCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  },
  toSentenceCase: function toSentenceCase(input) {
    if (input.toUpperCase() === input) {
      return input;
    }
    return input.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
      return str.toUpperCase();
    }).trim();
  },
  toLower: function toLower(str) {
    if ((0, _ramda.isNil)(str)) {
      return "";
    }

    return (0, _ramda.toLower)(str);
  },
  toUpper: function toUpper(str) {
    if ((0, _ramda.isNil)(str)) {
      return "";
    }

    return (0, _ramda.toUpper)(str);
  },
  replace: function replace(str, pattern, replacement) {
    return (0, _ramda.replace)(pattern, replacement, str);
  },
  doesTranslationKeyExist: function doesTranslationKeyExist(intl, translationKey) {
    return !(0, _ramda.isNil)(intl) && !(0, _ramda.isNil)(intl.messages) && !(0, _ramda.isNil)(intl.messages[translationKey]);
  },
  getHostnameFromRegex: function getHostnameFromRegex(url) {
    // run against regex
    var matches = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
    // extract hostname (will be null if no match is found)
    return matches && matches[1];
  },
  getStrByte: function getStrByte(str) {
    var count = 0;
    for (var i = 0, len = str.length; i < len; i++) {
      count += str.charCodeAt(i) < 256 ? 1 : 2;
    }
    return count;
  },


  /**
   * variable format {var}
   * 'string value: {var1}, {var2}', {var1: 'value1', var2: 'value2'}
   * -> 'string value: value1, value2'
   */
  replaceVarsInStr: function replaceVarsInStr() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var variablesToBeReplaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ((0, _ramda.isNil)(variablesToBeReplaces) || (0, _ramda.isEmpty)(variablesToBeReplaces)) {
      return str;
    }
    return Object.keys(variablesToBeReplaces).reduce(function (pre, cur) {
      return pre.replace(new RegExp('{' + cur + '}', 'g'), variablesToBeReplaces[cur]);
    }, str);
  },
  concatNonEmptyStrings: function concatNonEmptyStrings() {
    var strings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

    return strings.filter(function (s) {
      return !(0, _ramda.isNil)(s);
    }).filter(function (s) {
      return !(0, _ramda.isEmpty)(s);
    }).filter(function (s) {
      return !!s;
    }).join(separator);
  }
};

exports.default = StringUtility;
var arrayToCustomKebabCase = StringUtility.arrayToCustomKebabCase,
    hasJapanese = StringUtility.hasJapanese,
    customKebabCase = StringUtility.customKebabCase,
    customKebabCaseWithoutHyphen = StringUtility.customKebabCaseWithoutHyphen,
    displayValue = StringUtility.displayValue,
    generateLocale = StringUtility.generateLocale,
    getLocalizedString = StringUtility.getLocalizedString,
    getYesOrNo = StringUtility.getYesOrNo,
    lowerCaseAndReplaceSpace = StringUtility.lowerCaseAndReplaceSpace,
    mapToDashIfEmptyString = StringUtility.mapToDashIfEmptyString,
    renderFormattedHTMLLabel = StringUtility.renderFormattedHTMLLabel,
    renderFormattedLabel = StringUtility.renderFormattedLabel,
    replaceSpaceAndLowerCase = StringUtility.replaceSpaceAndLowerCase,
    stripCharacters = StringUtility.stripCharacters,
    titleCase = StringUtility.titleCase,
    customStartCase = StringUtility.customStartCase,
    addEllipsis = StringUtility.addEllipsis,
    toCamelCase = StringUtility.toCamelCase,
    toSentenceCase = StringUtility.toSentenceCase,
    toCamelCaseWithUnderScore = StringUtility.toCamelCaseWithUnderScore,
    toUpperCase = StringUtility.toUpperCase,
    startCase = StringUtility.startCase,
    doesTranslationKeyExist = StringUtility.doesTranslationKeyExist,
    getStrByte = StringUtility.getStrByte,
    concatNonEmptyStrings = StringUtility.concatNonEmptyStrings;
exports.arrayToCustomKebabCase = arrayToCustomKebabCase;
exports.hasJapanese = hasJapanese;
exports.customKebabCase = customKebabCase;
exports.customKebabCaseWithoutHyphen = customKebabCaseWithoutHyphen;
exports.displayValue = displayValue;
exports.generateLocale = generateLocale;
exports.getLocalizedString = getLocalizedString;
exports.getYesOrNo = getYesOrNo;
exports.lowerCaseAndReplaceSpace = lowerCaseAndReplaceSpace;
exports.mapToDashIfEmptyString = mapToDashIfEmptyString;
exports.renderFormattedHTMLLabel = renderFormattedHTMLLabel;
exports.renderFormattedLabel = renderFormattedLabel;
exports.replaceSpaceAndLowerCase = replaceSpaceAndLowerCase;
exports.stripCharacters = stripCharacters;
exports.titleCase = titleCase;
exports.customStartCase = customStartCase;
exports.addEllipsis = addEllipsis;
exports.toCamelCase = toCamelCase;
exports.toSentenceCase = toSentenceCase;
exports.toCamelCaseWithUnderScore = toCamelCaseWithUnderScore;
exports.toUpperCase = toUpperCase;
exports.startCase = startCase;
exports.doesTranslationKeyExist = doesTranslationKeyExist;
exports.getStrByte = getStrByte;
exports.concatNonEmptyStrings = concatNonEmptyStrings;